import React, { useEffect, useState } from 'react';
import Carousel from 'react-multi-carousel';
import 'react-multi-carousel/lib/styles.css';


export const HeroBanner = ({ images, onExplore }) => {
  const slides = images?.length ? images : [];
  const [activeIndex, setActiveIndex] = useState(0);

  useEffect(() => {
    if (slides.length <= 1) return undefined;
    const timer = setInterval(() => {
      setActiveIndex((current) => (current + 1) % slides.length);
    }, 5000);
    return () => clearInterval(timer);
  }, [slides.length]);

  if (!slides.length) return null;

  const goToSlide = (direction) => {
    setActiveIndex((current) => (current + direction + slides.length) % slides.length);
  };

  const activeSlide = slides[activeIndex];

  return (
    <section className="hero-banner homTopSlider" aria-label="Hero banner">
      <div className="hero-banner__inner row flex-column-reverse flex-lg-row align-items-center align-items-lg-start g-0">
        <div className="col-lg-7 col-12 hero-banner__text">
          <div className="text-start p-4">
            <p className="hero-banner__title fw-bold display-4" data-aos="fade-up">
              A Tradition of <span className="hero-banner__accent">Excellence</span> that emphasizes on much and not
              many
            </p>
            <button type="button" className="btn mt-4" id="button" data-aos="fade-up" onClick={onExplore}>
              Explore More
            </button>
          </div>
        </div>

        <div className="col-lg-5 col-12 hero-banner__visual">
          <div className="hero-banner__circle-wrap" data-aos="zoom-in">
            <div className="hero-banner__slide">
              <img
                className="hero-banner__slide-img"
                src={activeSlide.img}
                alt="Hero banner"
              />
            </div>
            {slides.length > 1 && (
              <>
                <button
                  type="button"
                  className="hero-banner__arrow hero-banner__arrow--prev"
                  aria-label="Previous slide"
                  onClick={() => goToSlide(-1)}
                >
                  ‹
                </button>
                <button
                  type="button"
                  className="hero-banner__arrow hero-banner__arrow--next"
                  aria-label="Next slide"
                  onClick={() => goToSlide(1)}
                >
                  ›
                </button>
              </>
            )}
          </div>
        </div>
      </div>
    </section>
  );
};


export  const HomeCard =({cards})=>{
    const responsive = {
        superLargeDesktop: {
          // the naming can be any, depends on you.
          breakpoint: { max: 4000, min: 3000 },
          items: 5
        },
        desktop: {
          breakpoint: { max: 3000, min: 1024 },
          items: 4
        },
        tablet: {
          breakpoint: { max: 1024, min: 500 },
          items: 2
        },
        mobile: {
          breakpoint: { max: 500, min: 0 },
          items: 1
        }
      };
      return(
        <Carousel className='' responsive={responsive} infinite={false} autoPlay={true}  autoPlaySpeed={3000} showDots={false}    removeArrowOnDeviceType={["tablet", "mobile",'desktop','superLargeDesktop']}>
             {
                    cards.map((el, index)=>{
                        return(
                              <a href={el.url} key={el.title || index}> 
                                <div className='col-11 rounded-3  homeTopCard' style={{marginLeft:'3px',cursor:'pointer'}}  >
                                    <div className='text-start p-3 px-4' style={{boxShadow: '0px 2.2356px 11.178px rgba(21, 87, 153, 0.08)'}}>
                                        {/* <img src={el.icon} alt="" /> */}
                                        <div className='HomeCards'> 
                                            {el.svg}
                                        </div>
                                        <p className='fw-bold py-3'>{el.title}</p>
                                        {/* <p>{el.text}</p>  */}
                                        {/* <br /> */}
                                    </div>
                                </div>
                              </a>
                        )
                    })
                }
        </Carousel>
      )
}
export default HomeCard
 


export const StudentAchiev =({stuAchiv})=>{
    const responsive = {
        superLargeDesktop: {
          breakpoint: { max: 4000, min: 3000 },
          items: 5
        },
        desktop: {
          breakpoint: { max: 3000, min: 1250 },
          items: 3
        },
        tablet: {
          breakpoint: { max: 1250, min: 850 },
          items: 2
        },
        mobile: {
          breakpoint: { max: 850, min: 0 },
          items: 1
        }
      };
      return(
        <Carousel className='ourOfferingSlider school-achievement-slider' responsive={responsive} infinite={true} autoPlay={true}  autoPlaySpeed={3000} showDots={false}    >
             {
                    stuAchiv.map((el, index)=>{
                        const title = el.studentName ?? el.name ?? '';
                        const detail = el.results ?? el.description ?? '';
                        const iconSrc = el.iconUrl ?? el.icon ?? '';
                        const label = typeof title === 'string' ? title : 'Achievement';
                        return(
                            <div className='school-achievement-slide' key={el.id ?? index}>  
                              <div className='school-achievement-card row rounded-5 align-items-center mx-0'>
                                <div className='col-sm-4 col-12'>
                                  <div className='school-achievement-icon-wrap bg-light rounded-5'>
                                    {iconSrc ? (
                                      <img
                                        className='school-achievement-icon-img'
                                        src={iconSrc}
                                        alt={label}
                                      />
                                    ) : null}
                                  </div> 
                                </div>
                                <div className='col-sm-8 col-12 school-achievement-body text-start'>
                                  <div className='school-achievement-title text-white'>{title}</div>
                                  {detail ? (
                                    <p className='school-achievement-detail rounded mb-0'>{detail}</p>
                                  ) : null}
                                </div>
                              </div> 
                            </div>
                        )
                    })
                }
        </Carousel>
      )
}


export const NewsBlog =({newsBlog})=>{
  const responsive = {
      superLargeDesktop: {
        // the naming can be any, depends on you.
        breakpoint: { max: 4000, min: 3000 },
        items: 3
      },
      desktop: {
        breakpoint: { max: 3000, min: 1024 },
        items: 2
      },
      tablet: {
        breakpoint: { max: 1024, min: 750 },
        items: 2
      },
      mobile: {
        breakpoint: { max: 750, min: 0 },
        items: 1
      }
    };
    return(
      <Carousel className='ourOfferingSlider' responsive={responsive} infinite={true} autoPlay={true}  autoPlaySpeed={3000} showDots={false}    removeArrowOnDeviceType={["tablet", "mobile",'desktop','superLargeDesktop']}>
           {
                  newsBlog.map((el)=>{
                      return(
                          <div className='p-2 text-start m-auto' >  
                              <div className=' ' >
                                  <img style={{width:'100%'}} src={el.img} alt="" />
                              </div>
                              <button className='btn rounded-5 p-0 px-3 mx-5' style={{background:'#FFD31D',marginTop:'-28px'}}>English</button>
                              <div className='d-flex justify-content-between p-2'>
                                  <p>{el.date}</p>
                                  <p>{el.hows}</p>
                                  <p><span style={{color:'#F37335'}}><i className="bi bi-tags-fill"></i></span> {el.publis}</p>
                              </div>
                              <div>
                                  <p className='fs-4 fw-bold'>{el.title}</p>
                                  <p className='mt-2'>{el.text}</p>
                              </div>

                              <p className='fw-bold my-3' style={{color:'#155799'}}>Read <span><i className="bi bi-arrow-right"></i></span></p>
                          </div>
                      )
                  })
              }
      </Carousel>
    )
}

export const Gallery =({gallery})=>{
  const responsive = {
      superLargeDesktop: {
        // the naming can be any, depends on you.
        breakpoint: { max: 4000, min: 3000 },
        items: 3
      },
      desktop: {
        breakpoint: { max: 3000, min: 1120 },
        items: 4
      },
      tablet: {
        breakpoint: { max: 1120, min: 850 },
        items: 3
      },
      mobile: {
        breakpoint: { max: 850, min: 0 },
        items: 1
      }
    };
    return(
      <Carousel className='ourOfferingSlider' responsive={responsive} infinite={true} autoPlay={true}  autoPlaySpeed={1500} showDots={false}    removeArrowOnDeviceType={["tablet", "mobile",'desktop','superLargeDesktop']}>
           {
                  gallery.map((el, index)=>{
                      return(
                          <div className='p-3' key={index}>  
                            <img style={{width:'100%' }}  src={el} alt="" />
                          </div>
                      )
                  })
              }
      </Carousel>
    )
}





export const OtherTrustees =({otherTrustees})=>{
  const responsive = {
      superLargeDesktop: {
        // the naming can be any, depends on you.
        breakpoint: { max: 4000, min: 3000 },
        items: 3
      },
      desktop: {
        breakpoint: { max: 3000, min: 1280 },
        items: 4
      },
      tablet: {
        breakpoint: { max: 1280, min: 950 },
        items: 3
      },
      mobile: {
        breakpoint: { max: 950, min: 0 },
        items: 1
      }
    };
    return(
      <Carousel className='ourOfferingSlider' responsive={responsive} infinite={false} autoPlay={true}  autoPlaySpeed={1500} showDots={false}     >
           {
                  otherTrustees.map((el)=>{
                      return(
                        <div >
                            <div >  
                              <img className='rounded-4' style={{width:'280px', height:'300px',objectFit:'cover'}}  src={el.img} alt="" />
                            </div>
                            <div>
                              <p className='fw-bold text-white'>{el.name}</p>
                              <p className='text-white'>{el.post}</p>
                            </div> 
                        </div>
                      )
                  })
              }
      </Carousel>
    )
}
 
 
export const InfrastructureSlide = ({images})=>{
  const responsive = {
    superLargeDesktop: {
      // the naming can be any, depends on you.
      breakpoint: { max: 4000, min: 3000 },
      items: 1
    },
    desktop: {
      breakpoint: { max: 3000, min: 1120 },
      items: 1
    },
    tablet: {
      breakpoint: { max: 1120, min: 850 },
      items: 1
    },
    mobile: {
      breakpoint: { max: 850, min: 0 },
      items: 1
    }
  };
  return(
    <Carousel className='ourOfferingSlider' responsive={responsive} infinite={true} autoPlay={true}  autoPlaySpeed={2000} showDots={true}    >
         {
                images.map((el)=>{
                    return(
                        <div className='p-3 rounded-5' >  
                          <img className='rounded-5' style={{width:'100%'}}  src={el} alt="" />
                        </div>
                    )
                })
            }
    </Carousel>
  )
}

export const Uniform = ({uniform})=>{
  const responsive = {
    superLargeDesktop: {
      // the naming can be any, depends on you.
      breakpoint: { max: 4000, min: 3000 },
      items: 1
    },
    desktop: {
      breakpoint: { max: 3000, min: 1120 },
      items: 1
    },
    tablet: {
      breakpoint: { max: 1120, min: 850 },
      items: 1
    },
    mobile: {
      breakpoint: { max: 850, min: 0 },
      items: 1
    }
  };
  return(
    <Carousel className='ourOfferingSlider' responsive={responsive} infinite={true} autoPlay={true}  autoPlaySpeed={2000} showDots={false}    removeArrowOnDeviceType={["tablet", "mobile",'desktop','superLargeDesktop']}>
         {
                uniform.map((el)=>{
                    return(
                        <div >  
                          <img style={{height:'50vh',width:'100%',objectFit:'cover',}}  src={el} alt="" />
                        </div>
                    )
                })
            }
    </Carousel>
  )
}


export const AlumniSpeaks = ({speak})=>{
  const responsive = {
    superLargeDesktop: {
      breakpoint: { max: 4000, min: 3000 },
      items: 1
    },
    desktop: {
      breakpoint: { max: 3000, min: 1120 },
      items: 1
    },
    tablet: {
      breakpoint: { max: 1120, min: 850 },
      items: 1
    },
    mobile: {
      breakpoint: { max: 850, min: 0 },
      items: 1
    }
  };
  return(
    <Carousel  responsive={responsive} infinite={true} autoPlay={true}  autoPlaySpeed={2500} showDots={false}    removeArrowOnDeviceType={["tablet", "mobile",'desktop','superLargeDesktop']}>
         {
                speak.map((el, index)=>{
                    const text = el.description ?? el.speak ?? "";
                    return(
                        <div className='col-11 my-2' key={el.id ?? index}>  
                            <p style={{ whiteSpace: "pre-line" }}>{text}</p>
                        </div>
                    )
                })
            }
    </Carousel>
  )
}